import apiClient from './apiClient';

const cantineAPI = {
  getAllCantines: (params = {}) => {
    // Construct query parameters
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    
    const queryString = queryParams.toString();
    return apiClient.get(`/cantine/index${queryString ? '?' + queryString : ''}?company_id=${localStorage.getItem('company_id')}`);
  },
  getCantine: (cantineId) => apiClient.get(`/cantine/show/${cantineId}?company_id=${localStorage.getItem('company_id')}`),
  createCantine: (cantineData) => apiClient.post(`/cantine/store?company_id=${localStorage.getItem('company_id')}`, cantineData),
  deleteCantine: (cantineId) => apiClient.delete(`/cantine/delete/${cantineId}?company_id=${localStorage.getItem('company_id')}`),
  getProductionTypes: () => apiClient.get(`/cantine/get-tipo-di-produzione?company_id=${localStorage.getItem('company_id')}`),
  duplicateCantine: (cantineId) => apiClient.post(`/cantine/duplicate/${cantineId}?company_id=${localStorage.getItem('company_id')}`),
  updateCantine: (cantineId, cantineData) => apiClient.post(`/cantine/update/${cantineId}?company_id=${localStorage.getItem('company_id')}`, cantineData),
  
  // cantina certification
  // certifyCantine: (cantineData) => apiClient.post(`/certifyData`, cantineData),
};

export default cantineAPI;
